"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const dropdown_1 = require("components/cosmos/v2/dropdown");
const moreOptionsButton_module_scss_1 = __importDefault(require("./moreOptionsButton.module.scss"));
const MoreOptionsButton = ({ label, onClick = (event) => event.preventDefault() }) => {
    return ((0, jsx_runtime_1.jsx)(dropdown_1.Dropdown.Slot, { children: ({ slot, className }) => ((0, jsx_runtime_1.jsx)(button_1.default, { variation: "custom", type: "button", slot: slot, onClick: onClick, className: (0, classnames_1.default)(className, moreOptionsButton_module_scss_1.default.button, 'hot-button _rounded-circle _border-0 _bg-transparent _w-7 _h-7 _text-gray-500'), "aria-label": label, children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'ellipsis-vertical'], className: "_text-4" }) })) }));
};
exports.default = MoreOptionsButton;
